module.exports = __webpack_public_path__ + "media/scan_failure.222f1ceb.wav";